import {IMediaItem} from '@interfaces/media';

export class GetFallbackData {
  static readonly type = '[Fallback] Get fallback data';
}

export class SetFallbackMediaToUpdate {
  static readonly type = '[Fallback] Set fallback media to update';

  constructor(public media: IMediaItem | null) {
  }
}

export class SetDefaultFallback {
  static readonly type = '[Fallback] Set default fallback';
}

export class SetBlackFallback {
  static readonly type = '[Fallback] Set black fallback';

  constructor(public value: boolean) {
  }
}

export class UpdateFallback {
  static readonly type = '[Fallback] Update fallback';

  constructor(public id: number) {
  }
}

